import type { TWebOtaApplyTiming } from '@lucimark/shared/models/tenant'

let lastKnownWebOtaApplyTiming: TWebOtaApplyTiming | null = null
let webOtaDeferredInitialWindowOpen = true

/** Reset when player clears registration (e.g. logout). */
export function resetWebOtaSessionGate(): void {
  lastKnownWebOtaApplyTiming = null
  webOtaDeferredInitialWindowOpen = true
}

function noteWebOtaApplyTimingFromServer(timing: TWebOtaApplyTiming | undefined): void {
  const t: TWebOtaApplyTiming = timing ?? 'immediate'
  const prev = lastKnownWebOtaApplyTiming
  lastKnownWebOtaApplyTiming = t
  if (prev === 'immediate' && t === 'next_app_restart') {
    webOtaDeferredInitialWindowOpen = false
  }
}

/**
 * Returns whether the player may run Web OTA download/reload for this event.
 * Updates session state for `next_app_restart` (consumes initial window on first allow).
 */
export function shouldAllowWebOtaAutoApplyNow(timing: TWebOtaApplyTiming | undefined): boolean {
  noteWebOtaApplyTimingFromServer(timing)
  const t: TWebOtaApplyTiming = timing ?? 'immediate'
  if (t === 'next_app_restart' && !webOtaDeferredInitialWindowOpen) {
    return false
  }
  if (t === 'next_app_restart') {
    webOtaDeferredInitialWindowOpen = false
  }
  return true
}
